import { useLegacyClientDetail } from './hooks';
import { convertToPresentationProps } from './logics';
import { LegacyClientDetailPresentation } from './presentations';

type Props = {
  id: number;
};

/**
 * クライアント詳細のコンテナコンポーネント
 */
export const LegacyClientDetail: React.FC<Props> = ({ id }) => {
  const {
    state: { data, customFieldDefinitions, partnerFeatureFlags },
  } = useLegacyClientDetail(id);

  const { clientDetail } = convertToPresentationProps({
    data,
    customFieldDefinitions,
    partnerFeatureFlags,
  });

  return <LegacyClientDetailPresentation clientDetail={clientDetail} />;
};
